/**
 * Log Levels Configuration
 * Minimal config for Logger utility
 *
 * Reads enabled log levels from NEXT_PUBLIC_LOG_LEVELS environment variable.
 * Format: comma-separated string (e.g., 'error,warn' or 'debug,log,warn,error')
 * Default: 'error,warn' if not set
 */

type LogLevel = 'debug' | 'log' | 'warn' | 'error';

const getEnabledLogLevels = (): LogLevel[] => {
  // Read from environment variable
  const envLevels =
    typeof process !== 'undefined'
      ? process.env.NEXT_PUBLIC_LOG_LEVELS
      : undefined;

  // Default to error and warn if not set
  const levelString = envLevels || 'error,warn';

  // Parse comma-separated string and validate levels
  const allValidLevels: LogLevel[] = ['debug', 'log', 'warn', 'error'];
  const parsedLevels = levelString
    .split(',')
    .map((level) => level.trim() as LogLevel)
    .filter((level) => allValidLevels.includes(level));

  return parsedLevels;
};

export const LOG_LEVELS = getEnabledLogLevels();

